module.exports = __webpack_public_path__ + "static/media/aero5.7abd84d5.jpg";